var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVectorTag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.752456 0.75H19.2475C19.2484 0.75 19.2492 0.750048 19.25 0.750133V24.2498C19.2484 24.25 19.2466 24.2501 19.2447 24.2499C19.2403 24.2495 19.2379 24.248 19.2374 24.2477C19.2374 24.2477 19.2374 24.2477 19.2373 24.2476L10.4484 17.6846L10.0001 17.3498L9.5515 17.6842L0.761628 24.2349C0.761333 24.2351 0.75898 24.2366 0.754584 24.237C0.752945 24.2372 0.751402 24.2372 0.75 24.237V0.750131C0.750773 0.750047 0.751593 0.75 0.752456 0.75Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorTag);
export default __webpack_public_path__ + "static/media/VectorTag.2877b3e14d022400cb62c07a67d928b0.svg";
export { ForwardRef as ReactComponent };